module.exports = __webpack_public_path__ + "06657d9170882b347825ef1de802134c.svg";